<template>
  <v-dialog
    v-model="dialog"
    width="500"
    >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        icon
        x-small
        v-on="on"
        v-bind="attrs"
        >
        <v-icon
          small
          color="error"
          >
          mdi-delete
        </v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-title>
        Eliminar concepto
      </v-card-title>

      <v-card-text>
        ¿Está seguro que desea eliminar el concepto {{ concept.name }}? Esta acción no se puede deshacer.
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
          text
          @click="dialog = false"
          >
          Cancelar
        </v-btn>

        <v-btn
          color="error"
          @click="perform"
          >
          Eliminar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { DeleteConcept } from '@/graphql/mutations/accounts'

export default {
  data: () => ({
    dialog: false
  }),

  props: {
    concept: {
      type: Object,
      required: true
    }
  },

  methods: {
    perform () {
      this.$apollo.mutate({
        mutation: DeleteConcept,
        variables: {
          input: {
            id: this.concept.id
          }
        }
      }).then ( res => {
        this.$emit('reload')
        this.dialog = false
      })
    }
  }
}
</script>
